<script>
    import Button from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import { api_host, domain_code_store, ppm_host } from '../../stores.js';
    import { doFetch } from '../../utils/Fetching.js';
    import { push } from 'svelte-spa-router';
    import { toast_message } from '../../utils/toast_message.js';
    import { onMount } from 'svelte';


	export let params = {};
    let password = '';
    let confirm_password = '';
    let domain_code = '';
    domain_code_store.subscribe(value => {
        domain_code = value;
    });
	
    let is_height_fit = true;
    onMount(() => {
        if (window.innerHeight < 730) {
            is_height_fit = false;
        }
    });

    const doSignin = () => { push('#/login'); }
	const doSignup = () => { push('#/register'); }

    const reset_password = async () => {
        if (password !== confirm_password) {
            toast_message(false, 'Please make sure your password match', 3000);
            return;
        }
		const lowerCaseLetters = /[a-z]/g;
		const upperCaseLetters = /[A-Z]/g;
		const numbers = /[0-9]/g;
		const missing_msg = [];
		if (!password.match(lowerCaseLetters)) missing_msg.push('A lowercase letter')
		if (!password.match(upperCaseLetters)) missing_msg.push('A capital letter')
		if (!password.match(numbers)) missing_msg.push('A number')
		if (password.length < 6) missing_msg.push('Minimum 6 characters')
		if (missing_msg.length > 0) {
			const error_msg = 'Password must contain:\n' + missing_msg.join('\n');
			toast_message(false, error_msg, 10000);
			return;  
		}
        const res = await doFetch(
            api_host + '/auth/reset_password',
            'POST',
            {
                uid: params.uid,
                activateToken: params.token,
                userId: params.userId,
                password
		    },
            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
        if (res.status) {
            toast_message(true, res.msg, 2000);
            setTimeout(() => {
                push('#/login');
            }, 1000);
        } else {
            toast_message(false, res.msg || 'Reset password failed', 3000);
        }
    }
</script>

<div style={is_height_fit ? "height: 100%;" : "height: 100%;overflow-y: scroll"} id="form_container">
    <div class="formholder">
        <div class="companyimageholder">
            <a href="{ppm_host}"><img src="/img/house-of-yards-app-logo.png" alt="company logo" /></a>
        </div>

        <div class="loginformholder">
            <div class="logintitle" style="font-size: 30px;text-align: center;margin-bottom: 10px;">Reset Password</div>
            <div class="pagetitle logintitle" style="text-align: center;">Your username is <b style="color: blue;display: block;">{params.userEmail}</b></div>

            <div class="ff password">
                <Textfield 
                    required
                    type="password"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={password}
                    label="New Password"
                />
            </div>

            <div class="ff confirm_password">
                <Textfield 
                    required
                    type="password"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={confirm_password}
                    label="Confirm Password"
                />
            </div>

            <div style="padding-left: 15px;color: #2f2f2f;">
                Password must contain:
                <ul>
                    <li>Minimum 6 characters</li>
                    <li>A lowercase letter</li>
                    <li>A capital letter</li>
                    <li>A number</li>
                </ul>
            </div>

            <div class="ff buttonbar">
                <Button variant="raised" class="button-shaped-round" on:click={() => {
                    reset_password();
                }}>Reset Password</Button>
            </div>
            
            <div class="exception">
                <div class="ff forgotpassword">
                    <a on:click={doSignin}>Login</a>
                </div>
        
                <!-- <div class="ff signup">
                    <a on:click={doSignup}>Don't have an account? Sign Up</a>
                </div> -->
            </div>
        </div>
    </div>
</div>

<style>
    /* globals */
    .ff {
        padding: 10px;
    }
    .formholder {
        width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
    }
    .companyimageholder {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 25px;
    }
    .companyimageholder img {
        height: 100px;
    }
    .loginformholder {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        gap: 10px;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: "pt pt"
                             "em em"
                             "pw pw"
                             "cpw cpw"
                             "rm rm"
                             "bb bb"
                             "fp su";
    }
    .exception {
        display: flex;
        justify-content: space-between;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 50px;
        }
        .loginformholder {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            gap: 10px;
            grid-template-columns: repeat(1, 1fr);
            grid-template-areas: "pt"
                                "em"
                                "pw"
                                "cpw"
                                "rm"
                                "bb"
                                "fp"
                                "su";
            }
            .forgotpassword, .signup {
                text-align: center;
            }
    }
    .pagetitle {
        grid-area: pt;
    }
    .email {
        grid-area: em;
    }
    .password {
        grid-area: pw;
    }
    .confirm_password {
        grid-area: cpw;
    }
    .rememberme {
        grid-area: rm;
    }
    .buttonbar {
        grid-area: bb;
    }
    * :global(.mdc-button) {
        width: 100% !important;
        color: white !important;
    }
    .forgotpassword {
        grid-area: fp;
        font-size: 14px;
    }
    * :global(a) {
        color: rgb(0, 179, 0) !important;
        cursor: pointer;
    }
    .signup {
        grid-area: su;
        font-size: 14px;
    }
</style>
